import React from 'react';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import st from './ProjectSliderSkeleton.module.css';

const ProjectSliderSkeleton = () => {
    return (
        <div className={st.skeletonBlock}>
            {/*<div className={st.skeleton}>*/}
                <Skeleton className={st.skeleton}/>

            {/*</div>*/}

        </div>
    );
};

export default ProjectSliderSkeleton;